import React, { useState, useEffect } from "react";

import rApp from "./rapp";
import { util } from "./util";
import Variants from "./variants";
import EmbVariants from "./embVariants";
import { NeedleIcon } from "./icons";
import EmbVariantsApplique from "./embVariantsApplique";
import ProductBanner from "./productBanner";

const visitorCountry = window.Shopify?.country || 'US'; // Defaults to 'US' if not available
// Hardcoded conversion rate for USD to CAD
const conversionRateCAD = 1.38;
const getCurrency = () => {
  const marketHandle =window.Shopify?.country || 'US';
  return marketHandle == 'CA' ? 'CAD' : 'USD';
};

const ProductMeta = ({
  discountMessage,
  embroideryPricing,
  thisProductPage,
  productObject,
  productOptionVals,
  productAdditionalVariantField,
  selectedFont,
  setProductClassCurrentVariant,
  typeTemplate = null,a,
  headerBanner,
  sizeGuideType
}) => {
  const [extraProperties, setExtraProperties] = useState(null);
  const [embVisibility, setEmbVisibility] = useState(false);
  const [embroiderySwatchData, setEmbroiderySwatchData] = useState(null);
  const [swatchData, setSwatchData] = useState(null);
  const [currentVariant, setCurrentVariant] = useState(
    thisProductPage.currentVariant
  );
  const [activeQty, setActiveQty] = useState(1);
  const [currentCount, setCurrentCount] = useState(1);
  const [nonEmbProduct, setNonEmbProduct] = useState(false);

  const isGiftCard = productObject.type.toLowerCase().includes("gift card");
  const embTag = productObject.tags.filter((tag) => tag.includes("embroidery"));
  const hasCookie = util.getCookie("embOpen");
  const isEmb = embTag.length > 0;
  const noBanner = productObject.tags.some((tag) => tag.includes("No Sale Banner"));

  const addToCart = () => {
    const properties = extraProperties !== null ? { ...extraProperties } : null;
    
    rApp.MinicartComponent.addVariant(
      currentVariant.id,
      thisProductPage.activeQty,
      properties
    );

    const dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "add_to_cart_track",
      ecommerce: {
        currency:getCurrency(),
        value: Number(
          util
            .formatMoney(currentVariant.price, "${{amount}}")
            .replace("$", "")
            .replace(",", "")
        ),
        items: [
          {
            item_list_id: `${productObject.id}`,
            item_list_name: `${productObject.title}`,
            item_id: `${currentVariant.id}`,
            item_name: `${productObject.title}`,
            affiliation: "Weezie Towels",
            currency:getCurrency(),
            coupon: null,
            discount: currentVariant?.compare_at_price
              ? util
                  .formatMoney(currentVariant?.compare_at_price, "${{amount}}")
                  .replace("$", "")
                  .replace(",", "") -
                util
                  .formatMoney(currentVariant?.price, "${{amount}}")
                  .replace("$", "")
                  .replace(",", "")
              : 0,
            index: 0,
            item_brand: "Weezie Towels",
            item_category: `${productObject.type}`,
            item_category2: `${currentVariant.option1}`,
            item_category3: null,
            item_category4: null,
            item_variant: null,
            price: Number(
              util
                .formatMoney(currentVariant.price, "${{amount}}")
                .replace("$", "")
                .replace(",", "")
            ),
            quantity: currentCount,
          },
        ],
      },
    });
  };

  const getExtraData = () => {
    const embroideryData = productAdditionalVariantField.variants.filter(
      (variant) =>
        !variant.title.includes("No Embroidery") &&
        !variant.title.includes("No Custom Embroidery")
    );
    const noEmbroideryData = productAdditionalVariantField.variants.filter(
      (variant) =>
        variant.title.includes("No Embroidery") ||
        variant.title.includes("No Custom Embroidery")
    );

    if (noEmbroideryData.length === 0) {
      setSwatchData(productAdditionalVariantField.variants);
    } else {
      setSwatchData(noEmbroideryData);
    }

    setEmbroiderySwatchData(embroideryData);
  };

  useEffect(() => {
    getExtraData();
  }, [currentVariant]);


  return (
    <div className="react__productmeta">
      <div className="product__pricing type">
        {currentVariant?.compare_at_price &&
        currentVariant?.compare_at_price > currentVariant?.price ? (
          <>
            <s>
              {util
                .formatMoney(currentVariant.compare_at_price, "${{amount}}")
                .replace(".00", "")}
            </s>
            <span className="type--bold">
              {util
                .formatMoney(currentVariant.price, "${{amount}}")
                .replace(".00", "")}{visitorCountry === 'CA' && ' CAD'}
            </span>
            <p className="type--small">
              {Math.floor(
                100 -
                  100 *
                    Math.abs(
                      currentVariant.price / currentVariant.compare_at_price
                    )
              )}
              % off
            </p>
          </>
        ) : (
          <span>
            {util
              .formatMoney(currentVariant.price, "${{amount}}")
              .replace(".00", "")}{visitorCountry === 'CA' && ' CAD'}
          </span>
        )}

        {discountMessage && (
          <p className="product__discount-message type type--small">
            {discountMessage}
          </p>
        )}
      </div>
     {!noBanner && <ProductBanner headerBanner={headerBanner}/>}
      <Variants
        extraProperties={extraProperties}
        setExtraProperties={(props) => setExtraProperties(props)}
        setMetaCurrentVariant={(variant) => {
          setProductClassCurrentVariant(variant);
          setCurrentVariant(variant);
        }}
        openEmbModal={() => setEmbVisibility(true)}
        productOptionVals={productOptionVals}
        productObject={productObject}
        productPage={thisProductPage}
        productData={swatchData}
        setCurrentCount={(count) => setCurrentCount(count)}
        activeQty={activeQty}
        setActiveQty={setActiveQty}
        sizeGuideType={sizeGuideType}
      />

      {!productAdditionalVariantField.variants.filter(
        (variant) => variant.id === currentVariant.id
      )[0].available &&
      productAdditionalVariantField.variants.filter(
        (variant) => variant.id === currentVariant.id
      )[0].metafields.variant_state === "notify-me" ? (
        <div className="product__notify">
          <p className="product__notify__title type type--medium">
            We’ll let you know when it’s back!
          </p>
          <form
            className="product__notify__form"
            onSubmit={(event) => notifyMe(event, email, currentVariant.id)}
            aria-label="Product notify when back in stock button"
          >
            {/* TODO: DISCUSS IF BELOW IS STILL NEEDED */}
            {/* <input className="product__notify__input type" type="text" placeholder="Your Email" onChange={event => setEmail(event.target.value)}></input>
            <button className="btn btn--navy">Notify Me</button> */}
            <a className="klaviyo-bis-trigger btn btn--navy btn--full" href="#">
              Notify Me When Available
            </a>
          </form>
        </div>
      ) : typeTemplate == "applique" ? (
        <div>
          {currentVariant.option1 !== "Custom" && (
            <div className="product__buttons__group">
              {currentVariant.available ? (
                <button
                  onClick={() => setEmbVisibility(true)}
                  className="product__buttons__add btn btn--full btn--navy"
                  ss-track-cart-add={currentVariant.sku}
                >
                  {productAdditionalVariantField.variants.filter(
                    (variant) => variant.id === currentVariant.id
                  )[0].inventory_quantity <= 0 &&
                  !currentVariant.name.includes("Gift Card")
                    ? "Preorder"
                    : "Personalize and Add to Bag"}
                  {/* TODO: DISCUSS IF BELOW IS STILL NEEDED */}
                  {/* {currentCount > 1 && <span>Each</span>} */}
                </button>
              ) : (
                <button className="product__buttons__add btn btn--full btn--navy sold-out">
                  Sold Out
                </button>
              )}

              {/* TODO: COMMENTED OUT AS PART OF ORIGINAL DESIGN PIVOT */}
              {/* <button className="product__wishlist-add">
                <HeartIcon elClass="product__wishlist-add__icon" />
              </button> */}
            </div>
          )}
        </div>
      ) : (
        <div className="product__buttons">
          {isEmb &&
            currentVariant.available &&
            !isGiftCard &&
            !productAdditionalVariantField.variants.filter(
              (variant) => variant.id === currentVariant.id
            )[0].metafields.noEmbroidery && (
              <button
                onClick={() => {
                  setEmbVisibility(true);
                }}
                className="product__buttons__embroidery btn btn--full trigger-embroidery"
              >
               <NeedleIcon elClass="product__buttons__icon" />
               {`Personalize it • +$${visitorCountry === 'CA' ? (embroideryPricing * conversionRateCAD).toFixed(2) : embroideryPricing} ${visitorCountry === 'CA' ? 'CAD' : 'per item'}`}
              </button>
            )}
          <div className="product__buttons__wrap">
            <div className="product__buttons__group product__buttons__group--cart">
              {currentVariant.available ? (
                <button
                  onClick={() => addToCart()}
                  className="product__buttons__add btn btn--full btn--navy"
                  ss-track-cart-add={currentVariant.sku}
                >
                  {productAdditionalVariantField.variants.filter(
                    (variant) => variant.id === currentVariant.id
                  )[0].inventory_quantity <= 0 &&
                  !currentVariant.name.includes("Gift Card")
                    ? "Preorder"
                    : "Add to Bag"}
                  {/* TODO: DISCUSS IF BELOW IS STILL NEEDED */}
                  {/* {currentCount > 1 && <span>Each</span>} */}
                </button>
              ) : (
                <button className="product__buttons__add btn btn--full btn--navy sold-out">
                  Sold Out
                </button>
              )}

              {/* TODO: COMMENTED OUT AS PART OF ORIGINAL DESIGN PIVOT */}
              {/* <button className="product__wishlist-add">
                <HeartIcon elClass="product__wishlist-add__icon" />
              </button> */}
            </div>
            <div className="product__quantity">
              <div className="product__count">
                <button
                  onClick={() =>
                    setActiveQty(activeQty <= 1 ? 1 : activeQty - 1)
                  }
                  className="product__count__button product__count__button--minus"
                  aria-label="Product quantity decrease"
                >
                  <svg
                    viewBox="0 0 15 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line
                      x1="0.5"
                      y1="1.03623"
                      x2="14.5"
                      y2="1.03623"
                      stroke="#14334C"
                      strokeWidth="1.2"
                    />
                  </svg>
                </button>

                <span className="product__count__number type">{activeQty}</span>

                <button
                  onClick={() => setActiveQty(activeQty + 1)}
                  className="product__count__button product__count__button--plus"
                  aria-label="Product quantity increase"
                >
                  <svg viewBox="0 0 15 14" fill="none">
                    <line
                      x1="7.46377"
                      y1="2.62269e-08"
                      x2="7.46377"
                      y2="14"
                      stroke="#14334C"
                      strokeWidth="1.2"
                    />
                    <line
                      x1="0.5"
                      y1="7.03623"
                      x2="14.5"
                      y2="7.03623"
                      stroke="#14334C"
                      strokeWidth="1.2"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {typeTemplate === "applique"
        ? isEmb && embVisibility &&(
            <EmbVariantsApplique
              setMetaCurrentVariant={(variant) => {
                setProductClassCurrentVariant(variant);
                setCurrentVariant(variant);
              }}
              singleFont={selectedFont}
              embTag={embTag}
              embVisibility={embVisibility}
              currentNonEmbVariant={thisProductPage.currentVariant}
              embroideryPricing={embroideryPricing}
              productOptionVals={productOptionVals}
              productObject={productObject}
              closeEmbModal={() => setEmbVisibility(false)}
              productData={embroiderySwatchData}
              discountMessage={discountMessage}
            />
          )
        : isEmb && embVisibility&&(
            <EmbVariants
              setMetaCurrentVariant={(variant) => {
                setProductClassCurrentVariant(variant);
                setCurrentVariant(variant);
              }}
              isGuideVisible={
                !productAdditionalVariantField.variants.filter(
                  (variant) => variant.id === currentVariant.id
                )[0].metafields.noEmbroidery || false
              }
              singleFont={selectedFont}
              embTag={embTag}
              embVisibility={embVisibility}
              currentNonEmbVariant={thisProductPage.currentVariant}
              embroideryPricing={embroideryPricing}
              productOptionVals={productOptionVals}
              productObject={productObject}
              closeEmbModal={() => setEmbVisibility(false)}
              productData={embroiderySwatchData}
              discountMessage={discountMessage}
            />
          )}
      {/* {typeTemplate === "applique"
        ? isEmb &&
          embVisibility && (
            <EmbVariantsApplique
              setMetaCurrentVariant={(variant) => {
                setProductClassCurrentVariant(variant);
                setCurrentVariant(variant);
              }}
              singleFont={selectedFont}
              embTag={embTag}
              embVisibility={embVisibility}
              currentNonEmbVariant={thisProductPage.currentVariant}
              embroideryPricing={embroideryPricing}
              productOptionVals={productOptionVals}
              productObject={productObject}
              closeEmbModal={() => setEmbVisibility(false)}
              productData={embroiderySwatchData}
              discountMessage={discountMessage}
            />
          )
        : isEmb &&
          embVisibility && (
            <EmbVariants
              setMetaCurrentVariant={(variant) => {
                setProductClassCurrentVariant(variant);
                setCurrentVariant(variant);
              }}
              singleFont={selectedFont}
              embTag={embTag}
              embVisibility={embVisibility}
              currentNonEmbVariant={thisProductPage.currentVariant}
              embroideryPricing={embroideryPricing}
              productOptionVals={productOptionVals}
              productObject={productObject}
              closeEmbModal={() => setEmbVisibility(false)}
              productData={embroiderySwatchData}
              discountMessage={discountMessage}
            />
          )} */}

      {/* GIFT REGGIE FORM - REQUIRES LOGGED IN USER WITH REGISTRY LIST ENGAGED */}
      <form
        method="post"
        action="/cart/add"
        acceptCharset="UTF-8"
        encType="multipart/form-data"
      >
        <input name="id" type="hidden" value={currentVariant.id} />

        <div className="gift-reggie-buttons">
          <div className="gift-reggie-registry-button">
            <input type="hidden" className="gift-reggie-hook" value="" />
          </div>
        </div>
      </form>
    </div>
  );
};

export default ProductMeta;
